import { faEllipsis, faHashtag } from "@fortawesome/free-solid-svg-icons";
import {
  faBell,
  faEnvelope,
  faBookmark,
  faFileLines,
  faCircleUser,
} from "@fortawesome/free-regular-svg-icons";

export const sidenavItems = [
  {
    id: 2,
    name: "Explore",
    icon: faHashtag,
  },
  {
    id: 3,
    name: "Notifications",
    icon: faBell,
  },
  {
    id: 4,
    name: "Messages",
    icon: faEnvelope,
  },
  {
    id: 5,
    name: "Bookmarks",
    icon: faBookmark,
  },
  {
    id: 6,
    name: "Lists",
    icon: faFileLines,
  },
  {
    id: 7,
    name: "Profile",
    icon: faCircleUser,
  },
  {
    id: 8,
    name: "More",
    icon: faEllipsis,
  },
];
